import { useRouter } from 'next/compat/router';
import { usePathname } from 'next/navigation';

export function useSafePathname() {
	const pathname = usePathname();
	const router = useRouter();

	// Если app router
	if (pathname) return pathname;

	// fallback для pages router
	return router?.pathname ?? '';
}
